exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-input-value[data-v-0d44f33d] {\n  width: 100%;\n  padding: 0.25rem 0;\n  border-bottom: 1px solid;\n}\n.form-input-value[data-v-0d44f33d]:focus {\n  border-bottom-color: var(--secondary);\n}", ""]);

// exports
